// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-card-container {
  padding: 0 20px 80px;
  margin-top: 80px;
  color: white; }
  @media screen and (min-width: 768px) {
    .preview-card-container {
      padding: 0 20px 150px;
      margin-top: 140px; } }
  .preview-card-container .counter-container {
    justify-content: center;
    display: flex;
    padding: 15px 0 40px;
    border-bottom: 0.5px solid #BFBFBF; }
    @media screen and (min-width: 768px) {
      .preview-card-container .counter-container {
        padding: 48px 0 148px; } }
    .preview-card-container .counter-container .counter-items {
      max-width: 1200px;
      width: 100%;
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      list-style: none; }
      .preview-card-container .counter-container .counter-items .counter-item {
        width: 100%;
        text-align: center;
        padding: 20px 10px; }
        .preview-card-container .counter-container .counter-items .counter-item h1 {
          font-size: 40px;
          line-height: 45px; }
        .preview-card-container .counter-container .counter-items .counter-item p {
          font-size: 16px;
          line-height: 25px; }
        @media screen and (min-width: 768px) {
          .preview-card-container .counter-container .counter-items .counter-item {
            width: 33.33%; } }
        @media screen and (min-width: 1024px) {
          .preview-card-container .counter-container .counter-items .counter-item {
            width: 20%; } }
  .preview-card-container .sub-heading {
    padding-top: 76px; }
    @media screen and (min-width: 768px) {
      .preview-card-container .sub-heading {
        padding: 145px 0 24px; } }
  .preview-card-container .form-container {
    width: 100%;
    max-width: 726px;
    padding: 0 18px; }
    .preview-card-container .form-container .MuiTextField-root {
      margin-bottom: 15px !important; }
      @media screen and (min-width: 768px) {
        .preview-card-container .form-container .MuiTextField-root.halfWidth {
          width: 50% !important; }
          .preview-card-container .form-container .MuiTextField-root.halfWidth:nth-child(odd) {
            width: calc( 50% - 15px) !important;
            margin-right: 15px; } }
    .preview-card-container .form-container .date-container {
      margin: 20px 0px; }
    .preview-card-container .form-container .preview-header-action {
      display: flex;
      flex-wrap: wrap;
      margin-top: 50px; }
      @media screen and (min-width: 768px) {
        .preview-card-container .form-container .preview-header-action {
          margin-top: 35px; } }
      .preview-card-container .form-container .preview-header-action button {
        width: 100%; }
        @media screen and (min-width: 768px) {
          .preview-card-container .form-container .preview-header-action button {
            width: 50%;
            margin: 0; }
            .preview-card-container .form-container .preview-header-action button:first-child {
              width: calc( 50% - 15px);
              margin-right: 15px; } }
`, "",{"version":3,"sources":["webpack://./src/pages/issue-card/finalStep/finalStep.scss"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAKhB,YAAY,EAAA;EAJZ;IAHF;MAII,qBAAqB;MACrB,iBAAiB,EAAA,EA2FpB;EAhGD;IASI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,kCAAkC,EAAA;IAChC;MAbN;QAcM,qBAAqB,EAAA,EAoCxB;IAlDH;MAiBQ,iBAAiB;MACjB,WAAW;MACX,SAAS;MACT,UAAU;MACV,aAAa;MACb,eAAe;MACf,uBAAuB;MACvB,mBAAmB;MACnB,gBAAgB,EAAA;MAzBxB;QA2BY,WAAW;QACX,kBAAkB;QASlB,kBAAkB,EAAA;QArC9B;UA8BgB,eAAe;UACf,iBAAiB,EAAA;QA/BjC;UAkCgB,eAAe;UACf,iBAAiB,EAAA;QAIrB;UAvCZ;YAwCc,aAAa,EAAA,EAQlB;QANG;UA1CZ;YA2Cc,UAAU,EAAA,EAKf;EAhDT;IAoDI,iBAAiB,EAAA;IACjB;MArDJ;QAsDM,qBAAqB,EAAA,EAExB;EAxDH;IA0DI,WAAW;IACX,gBAAgB;IAChB,eAAe,EAAA;IA5DnB;MA8DM,8BAA8B,EAAA;MAE5B;QAhER;UAiEU,qBAAqB,EAAA;UAjE/B;YAmEY,mCAAoC;YACpC,kBAAkB,EAAA,EACnB;IArEX;MA0EM,gBAAgB,EAAA;IA1EtB;MA6EM,aAAa;MACb,eAAe;MACf,gBAAgB,EAAA;MAChB;QAhFN;UAiFO,gBAAgB,EAAA,EAalB;MA9FL;QAoFQ,WAAW,EAAA;QACX;UArFR;YAsFU,UAAU;YACV,SAAQ,EAAA;YAvFlB;cAyFY,wBAAyB;cACzB,kBAAkB,EAAA,EACnB","sourcesContent":[".preview-card-container {\n  padding: 0 20px 80px;\n  margin-top: 80px;\n  @media screen and (min-width: 768px) {\n    padding: 0 20px 150px;\n    margin-top: 140px;\n  }\n  color: white;\n  .counter-container{\n    justify-content: center;\n    display: flex;\n    padding: 15px 0 40px;\n    border-bottom: 0.5px solid #BFBFBF;\n      @media screen and (min-width: 768px) {\n      padding: 48px 0 148px;\n    }\n    .counter-items{\n        max-width: 1200px;\n        width: 100%;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        list-style: none;\n        .counter-item{\n            width: 100%;\n            text-align: center;\n            h1{\n                font-size: 40px;\n                line-height: 45px;\n            }\n            p{\n                font-size: 16px;\n                line-height: 25px;\n            }\n            padding: 20px 10px;\n            \n            @media screen and (min-width: 768px) {\n              width: 33.33%;\n            }\n            @media screen and (min-width: 1024px) {\n              width: 20%;\n            }\n            // @media screen and (min-width: 1024px) {\n            //     width: 25%;\n            // }\n        }\n    }\n  }\n  .sub-heading{\n    padding-top: 76px;\n    @media screen and (min-width: 768px) {\n      padding: 145px 0 24px;\n    }\n  }\n  .form-container{\n    width: 100%;\n    max-width: 726px;\n    padding: 0 18px;\n    .MuiTextField-root{\n      margin-bottom: 15px !important;\n      &.halfWidth{\n        @media screen and (min-width: 768px) {\n          width: 50% !important;\n          &:nth-child(odd){\n            width: calc( 50% - 15px ) !important;\n            margin-right: 15px;\n          }\n        }\n      }\n    }\n    .date-container {\n      margin: 20px 0px;\n    }\n    .preview-header-action{\n      display: flex;\n      flex-wrap: wrap;\n      margin-top: 50px;\n      @media screen and (min-width: 768px) {\n       margin-top: 35px;\n      }\n      button{\n        width: 100%;\n        @media screen and (min-width: 768px) {\n          width: 50%;\n          margin:0;\n          &:first-child{\n            width: calc( 50% - 15px );\n            margin-right: 15px;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
